module.exports = __webpack_public_path__ + "img/crystal_14_b.c9136785.jpg";